// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"ShareButton_shareButton__1fT2K","content":"ShareButton_content__2bfOL","copyLink":"ShareButton_copyLink__qW_JE"};